<!-- Mobile top bar -->
<div class="sm:hidden fixed top-0 left-0 right-0 z-40 flex items-center justify-between bg-white border-b border-gray-200 px-4 py-3 shadow-sm">
  <button
    (click)="toggleSidebar()"
    type="button"
    aria-label="Ouvrir la navigation"
    class="inline-flex items-center justify-center p-2 rounded-lg text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary/30">
    <svg class="w-6 h-6" aria-hidden="true" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
    </svg>
  </button>
  <span class="font-alice text-lg text-primary tracking-wide">Administration</span>
  <a routerLink="/" class="text-xs text-gray-500 hover:text-primary">Site</a>
</div>

<!-- Backdrop mobile -->
@if (isSidebarOpen) {
  <div
    (click)="closeSidebar()"
    class="sm:hidden fixed inset-0 z-40 bg-gray-900/50 transition-opacity"
  aria-hidden="true"></div>
}

<!-- Sidebar -->
<aside
  id="admin-sidebar"
  class="fixed top-0 left-0 z-50 w-64 h-screen transition-transform duration-300 ease-in-out"
  [class.translate-x-0]="isSidebarOpen"
  [class.-translate-x-full]="!isSidebarOpen"
  [class.sm:translate-x-0]="true"
  aria-label="Sidebar admin">
  <div class="flex flex-col h-full bg-white border-r border-gray-200 shadow-sm">

    <!-- Branding -->
    <div class="flex items-center justify-between px-5 py-5 border-b border-gray-100">
      <div class="flex items-center gap-2">
        <div class="w-9 h-9 rounded-lg bg-gradient-to-br from-primary to-secondary flex items-center justify-center text-white font-alice text-lg shadow-sm">
          LB
        </div>
        <div>
          <p class="font-alice text-lg leading-tight text-gray-900">La Bourrée</p>
          <p class="font-raleway text-[10px] uppercase tracking-widest text-gray-400">Back-office</p>
        </div>
      </div>
      <button
        (click)="closeSidebar()"
        type="button"
        aria-label="Fermer la navigation"
        class="sm:hidden p-1.5 rounded-md text-gray-500 hover:bg-gray-100">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Nav -->
    <nav class="flex-1 overflow-y-auto px-3 py-4 font-raleway text-sm">
      <p class="px-3 mb-2 text-[10px] font-semibold uppercase tracking-wider text-gray-400">Tableau de bord</p>
      <ul class="space-y-1">
        <li>
          <a
            routerLink="/admin"
            routerLinkActive="bg-primary/10 text-primary font-semibold"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="closeSidebar()"
            class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors">
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2 7-7 7 7 2 2M5 10v10a1 1 0 001 1h3v-7h6v7h3a1 1 0 001-1V10"/>
            </svg>
            <span>Vue d'ensemble</span>
          </a>
        </li>
      </ul>

      <p class="px-3 mt-6 mb-2 text-[10px] font-semibold uppercase tracking-wider text-gray-400">Contenu</p>
      <ul class="space-y-1">
        <li>
          <a routerLink="/admin/evenements" routerLinkActive="bg-primary/10 text-primary font-semibold" (click)="closeSidebar()"
            class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors">
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
            </svg>
            <span>Événements</span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/actualites" routerLinkActive="bg-primary/10 text-primary font-semibold" (click)="closeSidebar()"
            class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors">
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"/>
            </svg>
            <span>Actualités</span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/ressources" routerLinkActive="bg-primary/10 text-primary font-semibold" (click)="closeSidebar()"
            class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors">
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
            </svg>
            <span>Ressources</span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/historique" routerLinkActive="bg-primary/10 text-primary font-semibold" (click)="closeSidebar()"
            class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors">
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <span>Historique</span>
          </a>
        </li>
      </ul>

      <p class="px-3 mt-6 mb-2 text-[10px] font-semibold uppercase tracking-wider text-gray-400">Communauté</p>
      <ul class="space-y-1">
        <li>
          <a routerLink="/admin/utilisateurs" routerLinkActive="bg-primary/10 text-primary font-semibold" (click)="closeSidebar()"
            class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors">
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>
            </svg>
            <span>Utilisateurs</span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/statistiques" routerLinkActive="bg-primary/10 text-primary font-semibold" (click)="closeSidebar()"
            class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors">
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
            </svg>
            <span>Statistiques</span>
          </a>
        </li>
        <li>
          <a routerLink="/admin/newsletter" routerLinkActive="bg-primary/10 text-primary font-semibold" (click)="closeSidebar()"
            class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors">
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
            </svg>
            <span>Newsletter</span>
          </a>
        </li>
      </ul>

      <p class="px-3 mt-6 mb-2 text-[10px] font-semibold uppercase tracking-wider text-gray-400">Site public</p>
      <ul class="space-y-1">
        <li>
          <a routerLink="/" (click)="closeSidebar()"
            class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors">
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"/>
            </svg>
            <span>Aller sur labourree.com</span>
          </a>
        </li>
      </ul>
    </nav>

    <!-- User card + logout -->
    <div class="px-3 pb-4 pt-2 border-t border-gray-100">
      @if (currentUser$ | async; as user) {
        <div class="flex items-center gap-3 px-2 py-2 rounded-lg bg-gray-50">
          <div class="w-9 h-9 rounded-full bg-gradient-to-br from-primary to-secondary text-white flex items-center justify-center font-raleway font-semibold text-sm shrink-0">
            {{ initials(user) }}
          </div>
          <div class="min-w-0 flex-1">
            <p class="text-sm font-semibold text-gray-800 truncate font-raleway">{{ user.firstName }} {{ user.lastName }}</p>
            <p class="text-[11px] text-gray-500 truncate">{{ user.email }}</p>
          </div>
          <button (click)="logout()" type="button" aria-label="Se déconnecter"
            class="p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h6a2 2 0 012 2v1"/>
            </svg>
          </button>
        </div>
      } @else {
        <div class="px-2 py-2 text-xs text-gray-400">Non connecté</div>
      }
    </div>
  </div>
</aside>
